import services from './../../services/service'; // Service Class
import SecondHeader from './../Second-Header/index.vue'; // Second Header
import MainFooter from './../Main-Footer/index.vue'; // Main Footer
let service = new services();

export default {
    name: 'Login',
    data () {
        return {
           user:{},
           disable_btn: false,
           forgot_processed:false,
           activation_error_message: false
        }
    },
    components: {
        'second-header': SecondHeader,
        'main-footer': MainFooter
    },
    methods: {
        reset() {
            localStorage.removeItem("cityneeds_user");
            localStorage.removeItem("cityneeds_token");
            localStorage.removeItem("cityneeds_token_key");
            //localStorage.removeItem("cityneeds_ref");
            localStorage.removeItem("cityneeds_prompt");
            //
            //remove session key here linked to session well @server

            if(this.$route.query.activation){
                var credentials = {"user_auth": this.$route.query.activation}
                service.activateEmail(this, credentials).then(response => {
                    if(response.status == 200) {
                        toastr.success("Email Activation Successfull", 'Kudos!'); 
                    }
                }).catch((err) => {
                    this.activation_error_message = true;
                    toastr.warning("Email Activation Failed", 'Warning!'); 
                })
            }
        },
        activateSignal(){

        },
        login() {
            this.disable_btn = true;
            var credentials = {
                user_email: this.user.email,
                user_password: this.user.password,
            }
            let navi = this.$router;
            if(credentials.user_email == null || credentials.user_email == undefined || credentials.user_email == '') {
                toastr.warning("Kindly enter email", 'Warning!');
            }else if(credentials.user_password == null || credentials.user_password == undefined || credentials.user_password == '') {
                toastr.warning("Kindly enter password", 'Warning!');
            }else {
               service.loginUser(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                         data.forEach(function(element) {
                            localStorage.setItem("cityneeds_user", element.user_fullname);
                            localStorage.setItem("cityneeds_token", element.user_session_key); //store session key here linked to session well @server
                            localStorage.setItem("cityneeds_token_key", element.user_token_key); 
                        }, this);
                        //ref prompt
                        localStorage.setItem("cityneeds_prompt", 0);
                        //check for current page
                        if(localStorage.getItem("cn_prv_page")){
                            navi.push(localStorage.getItem("cn_prv_page"));
                        }else{
                            navi.push('dashboard');
                        }
                        
                    }else{
                        toastr.warning("invalid login credentials", 'Warning!'); 
                        this.disable_btn = false;
                    }
                }).catch((err) => {
                    if(err.status == 404) {
                        toastr.warning("invalid login credentials", 'Warning!'); 
                        this.disable_btn = false;
                    }else{
                        toastr.warning("Please Re-try Once More", 'Warning!');
                        //log it //console.log(err)
                        this.disable_btn = false;
                    }
                })
            }
        },

        forgotPassword() {
            var credentials = {
                email: this.user.email,
            }

            if(credentials.email == null || credentials.email == undefined || credentials.email == '') {
                toastr.warning("Kindly enter email", 'Warning!');
            }else {
                service.forgotPassword(this, credentials).then((response) => {
                    if(response.status == 200) {
                      this.forgot_processed= true;
                    }
                }).catch((err) => {
                    if(err.status == 404) {
                        toastr.warning("Email not valid", 'Warning!'); 
                    }
                })
            }
        },

        resetForgot(){
            this.forgot_processed= false;
        },
        verifyEmail() {
            var credentials = {
                email: this.user.email,
                auth: this.user.auth,
            }

            if(credentials.email == null || credentials.email == undefined || credentials.email == '') {
                toastr.warning("Validation Failed", 'Warning!');
            }else if(credentials.auth == null || credentials.auth == undefined || credentials.auth == '') {
                toastr.warning("Validation Failed", 'Warning!');
            }else {
                service.verifyEmail(this, credentials).then((response) => {
                    if(response.status == 200) {
                        let data = response.body.data;
                        
                        this.$router.push('login');
                    }
                }).catch((err) => {
                    if(err.status == 404) {
                        toastr.warning("invalid credentials", 'Warning!'); 
                        this.$router.push('login');
                    }
                })
            }
        },
  },
  created: function() {
    this.reset();
  }
}


// WEBPACK FOOTER //
// ./src/components/Login/script.js